import TabViewModel from "../../../../Lib/Fs.SmartClient.Client/TabViewModel";
import FsUtility from "../../../../Lib/Fs.SmartClient.Client/FsUtility";
import ResetPasswordTokenRequest from "../../Scripts/AppServiceContract/ResetPasswordTokenRequest";
import ChangePasswordUpdateRequest from "../../Scripts/AppServiceContract/ChangePasswordUpdateRequest";
import ResetPasswordUpdateRequest from "../../Scripts/AppServiceContract/ResetPasswordUpdateRequest";
import { useView, autoinject, Container } from 'aurelia-framework'
import { OpenIdConnect, OpenIdConnectRoles } from "aurelia-open-id-connect";
import ChangePasswordAppService from "../../Scripts/AppServiceContract/ChangePasswordAppService";
import { User } from "oidc-client";
import { fs } from "../../../../Config/FsConfig";
import ActivateTokenRequest from "../../Scripts/AppServiceContract/ActivateTokenRequest";
import CreatePasswordData from "../../Scripts/AppServiceContract/CreatePasswordData";
import ActivateUserAppService from "../../Scripts/AppServiceContract/ActivateUserAppService";
import ActivateData from "../../Scripts/AppServiceContract/ActivateData";
import { PLATFORM } from 'aurelia-pal';

@autoinject
@useView(PLATFORM.moduleName("./ActivateView.html"))
export default class ChangePasswordVM extends TabViewModel {

    public OpenIdConnect: OpenIdConnect;
    constructor(openIdConnect: OpenIdConnect) {
        super();
        this.OpenIdConnect = openIdConnect;
    }

    public IsFromLogin: boolean = false;
    public ResourceId: string;
    public TokenKey: string;

    public NewPassword: string;
    public ConfirmPassword: string;

    public IsSuccess: boolean = false;
    public User: User;

    activate(params, route) {

        var self = this;

        this.ResourceId = params.ResourceId;
        this.TokenKey = params.TokenNo;

        var request = new ActivateTokenRequest();
        request.ResourceUID = this.ResourceId;
        request.TokenKey = this.TokenKey;
        request.IsChangePassword = false;

        var service = this.container.get(ActivateUserAppService) as ActivateUserAppService;
        service.CheckToken(request).done(function (result) {
            if (!result) {
                window.history.back();
            }
            var data = new ActivateData();
            data.TokenKey = self.TokenKey;
            data.UserId = self.TokenKey;
            service.ActivateUser(data).done(function (result) {
                self.IsSuccess = true;
            }).fail(function (error) {
                FsUtility.AlertErrorMessage(error);
            });
        }).fail(function (error) {
            FsUtility.AlertErrorMessage(error);
            window.history.back();
        });
    }
}
